import isUrl from 'is-url';
import { Transforms, createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';
import { RichTextEditorService } from './RichTextEditor.service';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

const insertImage = (editor, url) => {
  const text = { text: '' };
  const image = { type: 'image', url, children: [text] };
  Transforms.insertNodes(editor, image);

  const paragraph = {
    type: 'paragraph',
    children: [{ text: '' }],
  };
  Transforms.insertNodes(editor, paragraph);
};

const isImageUrl = url => {
  if (!url) return false;
  if (!isUrl(url)) return false;
  const ext = new URL(url).pathname.split('.').pop();
  return IMAGE_EXTENSIONS.includes(ext);
};

const withImages = editor => {
  const { insertData, isVoid } = editor;
  editor.isVoid = element => {
    return element.type === 'image' ? true : isVoid(element);
  };
  editor.insertData = data => {
    const text = data.getData('text/plain');
    const { files } = data;
    if (files && files.length > 0) {
      Array.from(files).forEach(async file => {
        const [mime] = file.type.split('/');
        if (mime === 'image') {
          const url = await RichTextEditorService.uploadImage(file);
          insertImage(editor, url);
        }
      });
    } else if (isImageUrl(text)) {
      insertImage(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};

export const editor = withImages(withHistory(withReact(createEditor())));
